// Disables the "+" quantity button on product cards once the quantity reaches the available stock.
// Loaded once per page from snippets/theme-variables.liquid; the guard keeps it to one run.
(function () {
  if (window.productCardQuantityInit) return;
  window.productCardQuantityInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    const quantityWrappers = document.querySelectorAll('.product-card [data-quantity-wrapper]');

    quantityWrappers.forEach((wrapper) => {
      if (wrapper.closest('.cart-form')) return;
      const input = wrapper.querySelector('[data-quantity-input]');
      const plusButton = wrapper.querySelector('[data-quantity-increment]');

      if (!input || !plusButton) return;

      function updatePlusButton() {
        const available = Math.max(
          0,
          parseInt(input.dataset.available || '0', 10)
        );

        const current = Math.max(
          1,
          parseInt(input.value || '1', 10)
        );

        const shouldDisable =
          available <= 0 ||
          current >= available;
        plusButton.disabled = shouldDisable;
        plusButton.classList.toggle('disabled-minus', shouldDisable);
      }

      input.addEventListener('input', updatePlusButton);
      plusButton.addEventListener('click', () => setTimeout(updatePlusButton, 0));
      wrapper
        .querySelector('[data-quantity-decrement]')
        ?.addEventListener('click', () => setTimeout(updatePlusButton, 0));

      updatePlusButton(); // Initial check
    });
  });
})();
